<a [routerLink]="route() ? [route()] : null" routerLinkActive="active" #rla="routerLinkActive" [routerLinkActiveOptions]="{exact: true}" class="sidenav-item" (click)="handleClick($event)">
	<i [class]="icon()" class="item-icon"></i>

	@if (!isSidenavCollapsed()) {
		<span class="item-label">{{ label() | translate }}</span>
	}

	@if (counterKey() && !isNaN(counterValue())) {
		<dc-badge [text]="counterValue().toString()"></dc-badge>
	}
</a>
